export default __webpack_public_path__ + "static/media/558.9d66b26b.gif";